export default {
      id: "sentiment-operator-neutral-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-operator-neutral-usage",
      toString: function () {
        return this.url;
      }
    }